import React from "react";
import { Link } from "react-router-dom";

import "./About.css";
import nameRole from "./nameandrole3.png";
import reactLogo from "./react_logo.png";
import reduxLogo from "./redux_logo.png";

export const About = () => {
  return (
    <div className="about-container">
      <div>
        <Link style={{ textDecoration: "none" }} to="/keyconcepts">
          <img className="about-logo-img" src={reactLogo}></img>
        </Link>
        <img src={nameRole}></img>
        <Link style={{ textDecoration: "none" }} to="/redux">
          <img className="about-redux-logo-img" src={reduxLogo}></img>
        </Link>
      </div>
    </div>
  );
};
